import { render, staticRenderFns } from "./CostBearerEducationClassicPayPreview.vue?vue&type=template&id=7faf09b6&scoped=true"
import script from "./CostBearerEducationClassicPayPreview.vue?vue&type=script&lang=ts"
export * from "./CostBearerEducationClassicPayPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faf09b6",
  null
  
)

export default component.exports